import { isEmpty, keys, mapValues, omitBy, pickBy } from 'lodash';

import { SelectedFacetAttributes, SelectedFacets } from '../constants';

export const formatSelectedFacets = (
  facets: SelectedFacetAttributes
): SelectedFacets =>
  omitBy(
    mapValues(facets, value => keys(pickBy(value))),
    isEmpty
  );
